// Not Using by App
// axios
import axios from 'axios'

const domain = "http://localhost:8080/api/"


export default axios.create({
  
  baseURL:domain
})

